"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _get = _interopRequireDefault(require("lodash/get"));
var _FuturesInstrumentTableComponent = _interopRequireDefault(require("./FuturesInstrumentTableComponent"));
var _instrumentPositionSelectors = require("../../redux/selectors/instrumentPositionSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var selectedInstrument = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state);
  var level1 = (0, _instrumentPositionSelectors.level1Selector)(state);
  var fetching = state.futures.instruments.fetching || state.futures.level1.level1SummaryFetching;
  var selectedInstrumentId = (0, _get["default"])(selectedInstrument, 'InstrumentId', '');
  return {
    fetching: fetching,
    level1: level1[selectedInstrumentId],
    selectedInstrument: selectedInstrument
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(_FuturesInstrumentTableComponent["default"]);